import {
  CommonMFE,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import { THost } from "@tpd-web-common-libs/nodejs-library/dist/src/mfe/common-mfe/types";
import { ContainerDiv } from "./ModalInfo.style";
import React from "react";

type TModalInfoProps = {
  id: string;
  __host__: THost;
  showHideModal: () => void;
};

const ModalInfo = (props: TModalInfoProps) => {
  const { __host__, id: containerID, showHideModal: hideModal } = props;

  const config = {
    text: "Per calcolare un preventivo relativo alla tua Azienda rivolgiti al tuo Agente.",
    title: "Attenzione",
    redButtonLabel: "Chiudi",
    redButtonCta: () => hideModal(),
  };

  return (
    <ContainerDiv>
      {config && (
        <ReactMFE.Remote
          id={CommonMFE.generateID(containerID, `${MFE_NAMES.tpdActionModalWidget}`)}
          __deps__={React}
          __host__={__host__}
          __mfeName__={MFE_NAMES.tpdActionModalWidget}
          config={config}
        />
      )}
    </ContainerDiv>
  );
};

export default ModalInfo;
